import { IUsageSummary } from "../interface/IUsageSummary";
import { Typography } from "@material-ui/core";
import { formatUsage } from "../usageUtils";
import { useTranslation } from "react-i18next";
import { centsToPrice } from "src/itsf/utils/priceUtils";

interface IParams {
    usageSummary: IUsageSummary;
}

export const CarouselItem = (props: IParams) => {
    const { usageSummary } = props;
    const { t } = useTranslation("usage");

    return (
        <div className="slide-content-border">
            <div className="slide-content">
                <Typography className="display-name" variant="body2">
                    {usageSummary.ratingSubtotalTypeDisplayName}
                </Typography>
                <Typography color="primary" variant="h2">
                    {formatUsage(usageSummary)}
                </Typography>
                <Typography variant="body2">{t("price", { price: centsToPrice(usageSummary.amount) })}</Typography>
            </div>
        </div>
    );
};
